/**
 * GA4 Analytics Helper for GTM integration
 * Pushes events to dataLayer for Google Tag Manager to process
 */

/**
 * GA4: Featured Units "More Info" click (homepage)
 */
export const trackFeaturedUnitMoreInfoClick = ({
  community_id = "",
  community_name = "",
  price = 0,
  beds = 0,
  baths = 0,
  sqft = 0,
  index = 0,                // 0-based in code
  unit_id = "",
  floorplan_name = "",
  total_cards = 0,
}) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "featured_unit_more_info_click",
      section: "move_in_specials",
      community_id,
      community_name,
      unit_id,                // OPTIONAL
      floorplan_name,         // OPTIONAL
      price,                  // number
      beds,                   // number
      baths,                  // number
      sqft,                   // number
      card_index: index + 1,  // publish 1-based
      total_cards_shown: total_cards, // OPTIONAL
    });
  }
};

/**
 * GA4: Cross-sell floorplan "Nearby Special" click
 */
export const trackCrossSellFloorplanClick = ({
  community_id = "",
  community_name = "",
  floorplan_slug = "",
  floorplan_name = "",
  price = 0,
  original_price = 0,
  beds = 0,
  baths = 0,
  sqft = 0,
  has_deal = false,
  deal_text = "",
  source_page = "",        // Which page the cross-sell appeared on
  source_community = "",   // The community page where cross-sell is shown
  index = 0,               // 0-based position in carousel
}) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "cross_sell_floorplan_click",
      section: "cross_sell_nearby",
      community_id,
      community_name,
      floorplan_slug,
      floorplan_name,        // OPTIONAL
      price,                 // Market price (discounted)
      original_price,        // Proforma price (list)
      price_discount: original_price > price ? original_price - price : 0,
      beds,                  // number
      baths,                 // number
      sqft,                  // number
      has_deal,              // boolean
      deal_text,             // OPTIONAL
      source_page,           // OPTIONAL
      source_community,      // OPTIONAL
      card_index: index + 1, // publish 1-based
    });
  }
};